import { SearchObject } from "app/common/Model/SearchObject";
import { exportSummaryOrderReport } from "app/services/InvoiceItemService";
import { getInvoiceItemDebtReport, exportExcelInvoiceItemDebtReport } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReportInvoiceDebtStore {
  listDataInvoiceDebt = null;
  searchInvoiceDebt = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentIds: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchInvoiceDebt = (searchInvoiceDebt) => {
    this.searchInvoiceDebt = {
      ...this.searchInvoiceDebt,
      ...searchInvoiceDebt,
    };
    this.pagingReportInvoiceDebt();
  };

  pagingReportInvoiceDebt = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchInvoiceDebt.departmentIds || this.searchInvoiceDebt.departmentIds.length === 0) {
      this.listDataInvoiceDebt = null;
      return;
    }
    
    const searchObj = this.normalizeSearchInvoiceDebt(this.searchInvoiceDebt);

    return await getInvoiceItemDebtReport({ ...searchObj })
      .then(({ data }) => {
        this.listDataInvoiceDebt = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo công nợ có lỗi");
      });
  };

  handleExportExcelInvoiceDebt = async () => {
    if (!this.searchInvoiceDebt.departmentIds || this.searchInvoiceDebt.departmentIds.length === 0) {
      toast.warning("Vui lòng chọn cơ sở trước khi xuất excel");
      return;
    }
    const searchObj = this.normalizeSearchInvoiceDebt(this.searchInvoiceDebt);
    try {
      const response = await exportExcelInvoiceItemDebtReport(searchObj);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_CONG_NO_HOA_DON.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
      toast.error("Có lỗi xảy ra khi xuất Excel");
    }
  };

  handleExportInvoiceDebt = async (searchObj) => {
    const search = { ...this.normalizeSearchInvoiceDebt(searchObj) };
    try {
      const response = await exportSummaryOrderReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_DON_HANG_TONG_HOP_TRUOC.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchInvoiceDebt = (rawSearch = {}) => {
    const { departmentIds, ...rest } = rawSearch;
    return {
      ...rest,
      departmentIds: departmentIds?.map((el) => el?.id),
    };
  };
  resetStore = () => {
    this.listDataInvoiceDebt = null;
    this.searchInvoiceDebt = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      departmentIds: null,
    };
  };
}
